import React from 'react';

function App() {
  return (
    <div className="App">
      <h1>Forge Training Hub</h1>
      <p>LLM Training Data Preparation Platform</p>
    </div>
  );
}

export default App;
